import { Coordinate } from "PosterEditor/hooks/use-coordinates";
import styles from "./toolbox-reverse-geocode-suggestions.module.css";
import useReverseGeocoder from "PosterEditor/hooks/use-reverse-geocoder";

interface ToolboxReverseGeocodeSuggestionsProps {
  coordinate: Coordinate;
  onSelectLandmarkText: (landmarkText: string) => void;
}

export const ToolboxReverseGeocodeSuggestions = (
  props: ToolboxReverseGeocodeSuggestionsProps
) => {
  const {
    landmark,
    error: placeNameLoadingError,
    isLoading: placenameIsLoading,
  } = useReverseGeocoder(props.coordinate.lat, props.coordinate.lng);

  const onClickLandmarkText = (landmarkText: string | undefined) => {
    if (landmarkText) {
      props.onSelectLandmarkText(landmarkText);
    }
  };

  return (
    <div className="container">
      {placenameIsLoading && <p>Loading...</p>}
      {placeNameLoadingError && <p>Error loading placename suggestions.</p>}
      {landmark && (
        <div className={styles.landmarkTextSuggestions}>
          {landmark.featureText && (
            <LandmarkSuggestion
              title={landmark.featureText}
              onClick={() => onClickLandmarkText(landmark.featureText)}
            />
          )}
          {landmark.locality && (
            <LandmarkSuggestion
              title={landmark.locality}
              onClick={() => onClickLandmarkText(landmark.locality)}
            />
          )}
          {landmark.place && (
            <LandmarkSuggestion
              title={landmark.place}
              onClick={() => onClickLandmarkText(landmark.place)}
            />
          )}
          {landmark.district && (
            <LandmarkSuggestion
              title={landmark.district}
              onClick={() => onClickLandmarkText(landmark.district)}
            />
          )}
          {landmark.region && (
            <LandmarkSuggestion
              title={landmark.region}
              onClick={() => onClickLandmarkText(landmark.region)}
            />
          )}
        </div>
      )}
    </div>
  );
};

const LandmarkSuggestion = (props: { title: string; onClick: () => void }) => {
  return (
    <button className={styles.landmarkButton} onClick={props.onClick}>
      {props.title}
    </button>
  );
};
